/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type FleetMapFleetsQueryVariables = Types.Exact<{
  regionId: Types.Scalars['String']['input']
  isSelfDriving?: Types.InputMaybe<Types.Scalars['Boolean']['input']>
}>

export type FleetMapFleetsQuery = {
  __typename?: 'Query'
  fleetMapFleets: Array<{ __typename?: 'Fleet'; id: string }>
}

export const FleetMapFleetsDocument = gql`
    query FleetMapFleets($regionId: String!, $isSelfDriving: Boolean) {
  fleetMapFleets(input: {regionId: $regionId, isSelfDriving: $isSelfDriving}) {
    id
  }
}
    `

/**
 * __useFleetMapFleetsQuery__
 *
 * To run a query within a React component, call `useFleetMapFleetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetMapFleetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetMapFleetsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      isSelfDriving: // value for 'isSelfDriving'
 *   },
 * });
 */
export function useFleetMapFleetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FleetMapFleetsQuery,
    FleetMapFleetsQueryVariables
  > &
    (
      | { variables: FleetMapFleetsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FleetMapFleetsQuery, FleetMapFleetsQueryVariables>(
    FleetMapFleetsDocument,
    options,
  )
}
export function useFleetMapFleetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FleetMapFleetsQuery,
    FleetMapFleetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FleetMapFleetsQuery, FleetMapFleetsQueryVariables>(
    FleetMapFleetsDocument,
    options,
  )
}
// @ts-ignore
export function useFleetMapFleetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FleetMapFleetsQuery,
    FleetMapFleetsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FleetMapFleetsQuery,
  FleetMapFleetsQueryVariables
>
export function useFleetMapFleetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FleetMapFleetsQuery,
        FleetMapFleetsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FleetMapFleetsQuery | undefined,
  FleetMapFleetsQueryVariables
>
export function useFleetMapFleetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FleetMapFleetsQuery,
        FleetMapFleetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    FleetMapFleetsQuery,
    FleetMapFleetsQueryVariables
  >(FleetMapFleetsDocument, options)
}
export type FleetMapFleetsQueryHookResult = ReturnType<
  typeof useFleetMapFleetsQuery
>
export type FleetMapFleetsLazyQueryHookResult = ReturnType<
  typeof useFleetMapFleetsLazyQuery
>
export type FleetMapFleetsSuspenseQueryHookResult = ReturnType<
  typeof useFleetMapFleetsSuspenseQuery
>
export type FleetMapFleetsQueryResult = Apollo.QueryResult<
  FleetMapFleetsQuery,
  FleetMapFleetsQueryVariables
>
